(() => {
  const host = document.querySelector('[data-bb-review]');
  if (!host || host.dataset.ready) return;
  host.dataset.ready = 'true';
  const cfg = window.BB_REVIEW_CONFIG || {};
  const asset = name => /^(https?:|data:|\/)/.test(name) ? name : (cfg.assets?.[name] || `assets/${name}`);
  const text = (name, fallback) => cfg.strings?.[name] || fallback;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const $ = selector => host.querySelector(selector);
  const $$ = selector => [...host.querySelectorAll(selector)];
  $$('[data-route]').forEach(a => { if (cfg.routes?.[a.dataset.route]) a.href = cfg.routes[a.dataset.route]; });
  const hero=$('.bb-world');
  const updateNavigation=()=>host.classList.toggle('is-past-hero',!hero || hero.getBoundingClientRect().bottom<=90);
  let navigationFrame;
  addEventListener('scroll',()=>{if(!navigationFrame)navigationFrame=requestAnimationFrame(()=>{navigationFrame=null;updateNavigation();});},{passive:true});
  addEventListener('resize',updateNavigation);updateNavigation();
  const readMotionPreference = key => { try { return sessionStorage.getItem(key) === 'true'; } catch { return false; } };
  const saveMotionPreference = (key,value) => { try { sessionStorage.setItem(key,String(value)); } catch { /* Motion still works when storage is unavailable. */ } };
  const state = window.__BBReview = { version: 'storefront-audit-20260907', gallery: 0, game: 'idle', feedPaused: readMotionPreference('bb-feed-paused'), motionPaused: false };
  // The public test reserves image geometry without downloading the entire
  // storefront while someone is deciding whether to play.
  const loadImage = image => {
    if(!image.dataset.bbSrc)return;
    if(image.dataset.bbSrcset){image.srcset=image.dataset.bbSrcset;delete image.dataset.bbSrcset;}
    image.src=image.dataset.bbSrc;delete image.dataset.bbSrc;
  };
  const mediaObserver = new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(entry.isIntersecting && entry.intersectionRect.width>0 && entry.intersectionRect.height>0){loadImage(entry.target);mediaObserver.unobserve(entry.target);}
  }),{threshold:.01});
  $$('img[data-bb-src]').forEach(image=>mediaObserver.observe(image));
  host.addEventListener('bb:load-media',event=>event.detail?.root?.querySelectorAll('img[data-bb-src]').forEach(loadImage));
  host.addEventListener('bb:observe-media',event=>event.detail?.root?.querySelectorAll('img[data-bb-src]').forEach(image=>mediaObserver.observe(image)));

  function dialog(name) {
    const el = $(`[data-${name}-dialog]`);
    if (!el) return;
    let opener, destination;
    $$(`[data-${name}-open]`).forEach(button => button.addEventListener('click', () => {
      opener = button; destination = null; el.showModal();
      if (button.hasAttribute('aria-expanded')) button.setAttribute('aria-expanded', 'true');
    }));
    $$(`[data-${name}-close]`).forEach(button => button.addEventListener('click', () => el.close()));
    el.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...el.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]')].filter(node => node.getClientRects().length && !node.closest('[hidden],[inert]'));
      const first = controls[0], last = controls.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    el.addEventListener('click', event => {
      if (event.target === el) {
        const r = el.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) el.close();
      }
      const link = event.target.closest('a');
      if (link) {
        const url = new URL(link.href, location.href);
        const currentURL = new URL(location.href);
        const sameView = url.searchParams.get('view') === currentURL.searchParams.get('view');
        const section = url.origin === location.origin && url.pathname === location.pathname && sameView && url.hash
          ? document.getElementById(decodeURIComponent(url.hash.slice(1))) : null;
        if (section) {
          event.preventDefault();
          destination = section.querySelector('h1,h2,h3') || section;
          if (location.hash !== url.hash) history.pushState(null, '', url.hash);
        }
        el.close();
        if (section) section.scrollIntoView({behavior: reduce.matches ? 'instant' : 'smooth', block: 'start'});
      }
    });
    el.addEventListener('close', () => {
      if (opener?.hasAttribute('aria-expanded')) opener.setAttribute('aria-expanded', 'false');
      if (destination) {
        destination.setAttribute('tabindex', '-1');
        destination.focus({ preventScroll: true });
      } else opener?.focus({ preventScroll: true });
    });
  }
  dialog('menu'); dialog('order');

  const motionButton = $('[data-motion-toggle]');
  const motionPaused = () => state.motionPaused || reduce.matches;
  function updateMotion() {
    host.classList.toggle('is-motion-paused', motionPaused());
    if (motionButton) {
      motionButton.disabled = reduce.matches;
      const label = reduce.matches ? text('reducedMotion','Reduced motion is on') : state.motionPaused ? text('playMotion','Play website motion') : text('pauseMotion','Pause website motion');
      motionButton.setAttribute('aria-label', label);
      motionButton.setAttribute('aria-pressed', String(motionPaused()));
      motionButton.innerHTML = (motionPaused() ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 10 7-10 7Z"/></svg>' : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14M16 5v14"/></svg>') + '<span>' + label + '</span>';
    }
    host.dispatchEvent(new CustomEvent('bb:motion-change', {detail:{paused:motionPaused()}}));
  }
  motionButton?.addEventListener('click', () => { state.motionPaused = !state.motionPaused; saveMotionPreference('bb-motion-paused',state.motionPaused); updateMotion(); });
  reduce.addEventListener('change', updateMotion);
  updateMotion();

  const video = $('[data-hero-video]');
  if (video) {
    const portrait = matchMedia('(max-width: 600px)');
    const poster = $('.bb-world-poster');
    let heroInView = true, gameOpen = false, loadVersion = 0;
    const updateHero = () => {
      if (heroInView && !gameOpen && !motionPaused() && !document.hidden && video.getAttribute('src')) video.play().catch(() => {});
      else video.pause();
    };
    const showDecodedFrame = () => {
      const version = loadVersion;
      const reveal = () => {
        if (version === loadVersion && video.readyState >= 2 && !video.error) video.classList.add('is-ready');
      };
      // The playing event can precede the first painted video frame. Keep the
      // matching poster visible until the decoder has actually presented it.
      if (video.requestVideoFrameCallback) video.requestVideoFrameCallback(reveal);
      else requestAnimationFrame(reveal);
    };
    const loadHero = () => {
      const media = cfg.hero || {};
      const p = portrait.matches ? (media.mobilePoster || media.poster) : media.poster;
      if (p && poster && !poster.closest('picture')) poster.src = asset(p);
      const source = portrait.matches ? (media.mobileVideo || media.video) : media.video;
      const wanted = source ? asset(source) : '';
      // Preference changes should pause the current film, not seek back to its
      // beginning. Resizing cancels any older pending poster decode/load.
      const version = ++loadVersion;
      if (wanted && video.getAttribute('src') === wanted) { updateHero(); return; }
      video.classList.remove('is-ready'); video.pause();
      if (!wanted || motionPaused() || navigator.connection?.saveData) return;
      const decoded = poster?.decode ? poster.decode().catch(() => {}) : Promise.resolve();
      decoded.then(() => {
        if (version !== loadVersion || motionPaused() || navigator.connection?.saveData) return;
        video.src = wanted; video.muted = true; video.load(); updateHero();
      });
    };
    video.addEventListener('playing', showDecodedFrame);
    video.addEventListener('error', () => video.classList.remove('is-ready'));
    new IntersectionObserver(entries => { heroInView = entries[0].isIntersecting; updateHero(); }, {threshold:.1}).observe(video);
    host.addEventListener('bb:game-state', e => {gameOpen = e.detail.open; updateHero();});
    host.addEventListener('bb:motion-change', () => { if(!video.getAttribute('src') && !motionPaused())loadHero();else updateHero(); });
    document.addEventListener('visibilitychange', updateHero);
    portrait.addEventListener('change', loadHero); reduce.addEventListener('change', loadHero);
    loadHero();
  }

  const stories = [
    { file:'feed-05.webp', alt:'Pink and green Bubble Bears bottles in the cooler' },
    { file:'bottle-on-ice.jpg', alt:'Rows of Bubble Bears bottles on ice' },
    { file:'bottle-asmr.jpg', alt:'Bubble Bears bottles being packed in the cooler' }
  ];
  const gallery = $('[data-gallery]');
  if (gallery) {
    const track = $('[data-gallery-track]');
    const cards = [];
    for (let n = 0; n < 9; n++) {
      const i = n % stories.length;
      const button = document.createElement('button');
      button.className = 'bb-gallery-card'; button.type = 'button'; button.dataset.photo = i;
      button.setAttribute('aria-label', stories[i].alt); button.tabIndex = -1;
      const img = document.createElement('img'); img.src = asset(stories[i].file); img.alt = stories[i].alt;
      img.width = 600; img.height = 750; img.loading = 'eager'; img.draggable = false;
      button.append(img); track.append(button); cards.push(button);
    }
    let selected = 4, dragging = false, lastX = 0, moved = false, timer, navigationTimer;
    let navigating = false;
    const position = index => cards[index].offsetLeft - (gallery.clientWidth - cards[index].offsetWidth) / 2;
    const setSelected = index => {
      selected = index; state.gallery = index % 3;
      cards.forEach((card,i) => { card.classList.toggle('is-current',i === index); card.setAttribute('aria-pressed',String(i === index)); });
      $('[data-gallery-status]').textContent = text('photo','Photo') + ` ${state.gallery + 1} / 3`;
    };
    const center = (index, smooth = true) => {
      if (index < 0 || index >= cards.length) {
        index = ((index % stories.length) + stories.length) % stories.length + stories.length;
        smooth = false;
      }
      navigating = true;
      clearTimeout(navigationTimer);
      setSelected(index); gallery.scrollTo({ left: position(index), behavior:smooth && !reduce.matches ? 'smooth' : 'instant' });
      navigationTimer = setTimeout(() => { navigating = false; settle(); }, smooth && !reduce.matches ? 500 : 80);
    };
    const settle = () => {
      if (dragging || navigating) return;
      const nearest = cards.reduce((best, card, i) => Math.abs(position(i)-gallery.scrollLeft) < Math.abs(position(best)-gallery.scrollLeft) ? i : best, 0);
      setSelected(nearest);
      if (nearest < 3 || nearest > 5) center(nearest % 3 + 3, false);
    };
    gallery.addEventListener('scroll', () => {
      const nearest = cards.reduce((best, card, i) => Math.abs(position(i)-gallery.scrollLeft) < Math.abs(position(best)-gallery.scrollLeft) ? i : best, 0);
      if (!navigating) setSelected(nearest); clearTimeout(timer); timer = setTimeout(settle, 180);
    }, { passive:true });
    $('[data-gallery-prev]').addEventListener('click', () => center(Math.max(0,selected-1)));
    $('[data-gallery-next]').addEventListener('click', () => center(Math.min(8,selected+1)));
    cards.forEach((card,i) => card.addEventListener('click', () => { if (!moved) center(i); }));
    gallery.addEventListener('keydown', e => {
      if (['ArrowLeft','ArrowRight'].includes(e.key)) { e.preventDefault(); center(selected + (e.key === 'ArrowLeft' ? -1 : 1)); }
    });
    gallery.addEventListener('pointerdown', e => {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(navigationTimer); navigating = false;
      gallery.scrollTo({ left: gallery.scrollLeft, behavior: 'instant' });
      dragging = true; moved = false; lastX = e.clientX;
      gallery.classList.add('is-dragging'); gallery.setPointerCapture(e.pointerId);
    });
    gallery.addEventListener('pointermove', e => {
      if (!dragging) return;
      const dx = e.clientX-lastX; if (Math.abs(dx)>2) moved=true;
      gallery.scrollLeft -= dx; lastX=e.clientX;
    });
    const end = e => {
      if (!dragging) return; dragging=false;
      gallery.classList.remove('is-dragging'); if(gallery.hasPointerCapture(e.pointerId)) gallery.releasePointerCapture(e.pointerId);
      center(selected); setTimeout(() => { moved=false; }, 100);
    };
    gallery.addEventListener('pointerup', end); gallery.addEventListener('pointercancel', end);
    new ResizeObserver(() => center(state.gallery+3,false)).observe(gallery);
    requestAnimationFrame(() => center(4,false));
  }

  const defaultFeed = [
    {image:'feed-01.webp',url:'https://www.instagram.com/p/DcoEoeljlMs/',alt:'Two colorful Bubble Bears drinks at the market'},
    {image:'feed-02.webp',url:'https://www.instagram.com/p/DcY2qOCjl0a/',alt:'An orange Bubble Bears drink with candy'},
    {image:'feed-05.webp',url:'https://www.instagram.com/reel/Db03x0NO5cp/',alt:'Pink and green Bubble Bears bottles on ice'},
    {image:'feed-06.webp',url:'https://www.instagram.com/p/DKafKQkuWJy/',alt:'Bubbles and Berry with their drinks'}
  ];
  let feedLanes=[cfg.feed || defaultFeed,(cfg.feedArchive || [defaultFeed[2],defaultFeed[3],defaultFeed[0]])],pendingFeed;
  const rows = [];
  let feedFrame = 0, lastFeedFrame = 0;
  const canMoveFeed = () => !reduce.matches && !state.feedPaused && !motionPaused() && !document.hidden && rows.some(row => row.visible && !row.holds.size);
  function scheduleFeed() {
    if(pendingFeed && !rows.some(row=>row.holds.size)){feedLanes=pendingFeed;pendingFeed=null;rows.forEach(row=>row.build());}
    state.feedHeld = rows.map(row => row.holds.size > 0);
    if (canMoveFeed() && !feedFrame) feedFrame = requestAnimationFrame(frameFeed);
    else if (!canMoveFeed()) { cancelAnimationFrame(feedFrame); feedFrame = 0; lastFeedFrame = 0; }
  }
  function frameFeed(now) {
    feedFrame = 0;
    const dt = lastFeedFrame ? Math.min((now-lastFeedFrame)/1000,.05) : 0;
    lastFeedFrame = now;
    rows.forEach(row => { if (row.visible && !row.holds.size) row.tick(dt); });
    scheduleFeed();
  }
  $$('[data-feed-row]').forEach((row,rowIndex) => {
    let cards=[], phase=0, width=0, stride=0, circumference=0;
    const lane = { visible:false, holds:new Set(), tick, build };
    const slotX = card => ((card.index*stride+phase+stride)%circumference+circumference)%circumference-stride;
    function paint(card) {
      card.x=slotX(card);
      card.el.style.transform=`translate3d(${card.x}px,0,0)`;
    }
    function hold(card) {
      const held=card.hovered || card.focused;
      if(held) lane.holds.add(card); else lane.holds.delete(card);
      card.el.classList.toggle('is-held',held);
      row.classList.toggle('has-held-photo', lane.holds.size > 0);
      cards.forEach(other => other.el.classList.toggle('is-neighbor', [...lane.holds].some(active => {
        const distance = Math.abs(active.index - other.index);
        return distance === 1 || distance === cards.length - 1;
      })));
      scheduleFeed();
    }
    function clearPointer() {
      cards.forEach(card=>{card.hovered=false;hold(card);});
    }
    function build() {
      const focusedIndex=cards.findIndex(card=>card.el===document.activeElement);
      cards.forEach(card=>lane.holds.delete(card));
      row.replaceChildren(); row.classList.remove('has-held-photo'); cards=[]; phase=0;
      row.classList.toggle('is-still',reduce.matches);
      width=innerWidth<=600 ? 280 : Math.min(470,Math.max(270,innerWidth*.31));
      stride=width+14;
      const items = feedLanes[rowIndex].filter(Boolean);
      const count=reduce.matches ? items.length : Math.max(items.length*2,Math.ceil(row.clientWidth/stride)+3);
      circumference=count*stride;
      for(let i=0;i<count;i++) {
        const item=items[i%items.length]; if(!item) continue;
        const a=document.createElement('a');a.className='bb-feed-card';a.href=item.url;a.target='_blank';a.rel='noreferrer';a.draggable=false;a.setAttribute('aria-label',item.alt+text('openInstagram','. Open on Instagram.'));
        if(i>=items.length){a.tabIndex=-1;a.setAttribute('aria-hidden','true');}
        const image=document.createElement('img');const imageUrl=/^https?:/.test(item.image)?item.image:asset(item.image);
        if(cfg.deferBelowFoldMedia)image.dataset.bbSrc=imageUrl;else image.src=imageUrl;
        image.alt=item.alt;image.width=600;image.height=750;image.loading='lazy';image.decoding='async';image.draggable=false;image.addEventListener('error',()=>{const fallback=defaultFeed[i%defaultFeed.length];if(image.dataset.usedFallback)return;image.dataset.usedFallback='true';image.src=asset(fallback.image);image.alt=fallback.alt;a.href=fallback.url;a.setAttribute('aria-label',fallback.alt+text('openInstagram','. Open on Instagram.'));});const frame=document.createElement('span');frame.className='bb-feed-frame';frame.append(image);a.append(frame);row.append(a);
        const card={el:a,index:i,x:0,hovered:false,focused:false};cards.push(card);
        a.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){card.hovered=true;hold(card);}});
        a.addEventListener('pointerleave',()=>{card.hovered=false;hold(card);});
        a.addEventListener('focus',()=>{
          card.focused=a.matches(':focus-visible');
          if(card.focused && !reduce.matches){
            // Move the entire shared row only when a keyboard user focuses
            // an offscreen original; never pin or duplicate a photograph.
            const x=slotX(card), target=Math.max(14,Math.min(x,row.clientWidth-width-14));
            phase+=target-x;cards.forEach(paint);
          }
          hold(card);
        });
        a.addEventListener('blur',()=>{card.focused=false;hold(card);});
        if (!reduce.matches) paint(card);
      }
      if(lane.visible)row.querySelectorAll('img[data-bb-src]').forEach(loadImage);
      if(focusedIndex>=0)cards[Math.min(focusedIndex,cards.length-1)]?.el.focus({preventScroll:true});
      scheduleFeed();
    }
    function tick(dt) {
      phase=(phase+(rowIndex===0?-32:29)*dt)%circumference;
      cards.forEach(paint);
    }
    row.addEventListener('dragstart',event=>event.preventDefault());
    row.addEventListener('pointerleave',clearPointer);
    row.addEventListener('pointercancel',clearPointer);
    addEventListener('blur',clearPointer);
    const observer=new IntersectionObserver(entries=>{
      lane.visible=entries[0].isIntersecting;
      if(lane.visible)row.querySelectorAll('img[data-bb-src]').forEach(loadImage);
      if(!lane.visible) clearPointer();
      scheduleFeed();
    });observer.observe(row);
    rows.push(lane);build();
  });
  // Pull only a public snapshot. Instagram authorization stays in the sync job.
  const feedSection=$('#feed');
  if(feedSection && cfg.feedUrl){
    const cachedPosts={DcoEoeljlMs:'feed-01.webp',DcY2qOCjl0a:'feed-02.webp',DcW4f9tBB3g:'feed-03.webp',DcEcSRKDga1:'feed-04.webp',Db03x0NO5cp:'feed-05.webp',DKafKQkuWJy:'feed-06.webp'};
    const fetchFeed=async()=>{
      state.feedSource='last-known-good';
      try{
        const response=await fetch(cfg.feedUrl,{credentials:'omit',signal:AbortSignal.timeout(10000)});
        if(!response.ok)return;
        const payload=await response.json();
        if(payload.username!=='drinkbubblebears' || !Array.isArray(payload.items))return;
        const seen=new Set();
        const entries=payload.items.map(item=>{
          try{
            const url=new URL(item.permalink),code=url.pathname.split('/').filter(Boolean).at(-1);
            const source=item.image || (cachedPosts[code] && asset(cachedPosts[code])) || item.thumbnail_url || (item.media_kind!=='reel' && item.media_url);
            const image=/^bb-instagram-[\w-]+\.jpg$/.test(source) ? new URL(source,new URL(cfg.feedUrl,location.href)) : new URL(source,location.href);
            if(url.protocol!=='https:' || !['www.instagram.com','instagram.com'].includes(url.hostname) || image.protocol!=='https:' || seen.has(url.href))return null;
            seen.add(url.href);return {url:url.href,image:image.href,alt:(item.caption || 'Bubble Bears on Instagram').slice(0,180),date:Date.parse(item.taken_at || item.timestamp)||0};
          }catch{return null;}
        }).filter(Boolean).sort((a,b)=>b.date-a.date);
        if(entries.length<2)return;
        const latest=entries.slice(0,6),archive=entries.slice(6,18);
        const featured=(cfg.feedArchive || defaultFeed).filter(item=>!latest.some(recent=>recent.url===item.url));
        pendingFeed=[latest,archive.length>=3?archive:[...archive,...featured].slice(0,12)];
        if(!pendingFeed[1].length)pendingFeed[1]=latest.slice().reverse();
        state.feedUpdatedAt=payload.fetched_at;state.feedSource='instagram-snapshot';scheduleFeed();
      }catch{state.feedSource='last-known-good';}
    };
    const observer=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){observer.disconnect();fetchFeed();}},{rootMargin:'600px'});observer.observe(feedSection);
  }
  let resizeTimer;addEventListener('resize',()=>{clearTimeout(resizeTimer);resizeTimer=setTimeout(()=>rows.forEach(r=>r.build()),200);});
  const feedToggle=$('[data-feed-toggle]');
  function updateFeedToggle(){
    if(!feedToggle)return;
    const paused=state.feedPaused || motionPaused();
    feedToggle.disabled=motionPaused();
    feedToggle.setAttribute('aria-pressed',String(paused));
    feedToggle.setAttribute('aria-label',reduce.matches?text('feedReducedMotion','Bubblefeed motion disabled by your motion preference'):state.motionPaused?text('feedWebsitePaused','Bubblefeed paused — resume website motion in Menu'):paused?text('playFeed','Play Bubblefeed motion'):text('pauseFeed','Pause Bubblefeed motion'));
    feedToggle.innerHTML=paused?'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 10 7-10 7Z"/></svg>':'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14M16 5v14"/></svg>';
  }
  reduce.addEventListener('change',()=>{rows.forEach(r=>r.build());updateFeedToggle();scheduleFeed();});
  host.addEventListener('bb:motion-change',()=>{updateFeedToggle();scheduleFeed();});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)rows.forEach(r=>r.visible && r.tick(0));scheduleFeed();});
  feedToggle?.addEventListener('click',()=>{state.feedPaused=!state.feedPaused;saveMotionPreference('bb-feed-paused',state.feedPaused);updateFeedToggle();scheduleFeed();});
  updateFeedToggle();

  const bottle=$('[data-bottle-toy]');
  if(bottle){
    if(cfg.bottleImage){$('[data-bottle-art]').src=asset(cfg.bottleImage);$('[data-bottle-art]').alt=text('bottleAlt','Bubble Bears pink bottle');bottle.classList.add('has-cutout');}
    bottle.addEventListener('click',()=>{if(reduce.matches)return;bottle.classList.remove('is-spinning');requestAnimationFrame(()=>requestAnimationFrame(()=>bottle.classList.add('is-spinning')));});
    bottle.addEventListener('animationend',()=>bottle.classList.remove('is-spinning'));
    bottle.addEventListener('pointermove',e=>{if(reduce.matches||bottle.classList.contains('is-spinning')||e.pointerType!=='mouse')return;const r=bottle.getBoundingClientRect();const tilt=((e.clientX-r.left)/r.width-.5)*16;bottle.firstElementChild.style.transform=`rotate(${tilt}deg) rotateY(${tilt}deg)`;});
    bottle.addEventListener('pointerleave',()=>{bottle.firstElementChild.style.transform='';});
  }
  if(cfg.marketImage&&$('[data-market-photo]')){$('[data-market-photo]').src=asset(cfg.marketImage);$('[data-market-photo]').alt=text('marketAlt','A Bubble Bears drink at the market');}

  // Homepage live entry owns its persistent game instance when explicitly enabled.
  if(cfg.liveEntry && $('[data-live-game]'))return;

  // Website launch v1 is a normal navigation with an explicit one-shot intent.
  // The game owns readiness, entry and saves. Never download a second engine
  // in a hidden iframe: cross-site storage can split an existing player's save.
  if(cfg.externalGameUrl){
    const launches=$$('[data-game-start]');
    const labels=new Map();
    let recoveryTimer;
    const resetLaunch=()=>{
      clearTimeout(recoveryTimer);state.game='idle';
      launches.forEach(link=>{
        link.removeAttribute('aria-busy');link.classList.remove('is-pressed');
        const label=link.querySelector('[data-game-label]');
        if(label&&labels.has(link))label.textContent=labels.get(link);
      });
    };
    launches.forEach(link=>{
      if(link.tagName==='A')link.href=cfg.externalGameUrl;
      const label=link.querySelector('[data-game-label]');
      if(label)labels.set(link,label.textContent);
      link.addEventListener('click',event=>{
        // Keep open-in-new-tab and ordinary link behavior available.
        if(event.defaultPrevented||event.button>0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        if(state.game==='leaving'){event.preventDefault();return;}
        state.game='leaving';link.setAttribute('aria-busy','true');
        if(label&&link.dataset.loadingLabel)label.textContent=link.dataset.loadingLabel;
        // Navigation starts immediately. A blocked navigation can be retried;
        // Back/bfcache restores the original button rather than a stuck loader.
        recoveryTimer=setTimeout(resetLaunch,8000);
        if(link.tagName!=='A')location.assign(cfg.externalGameUrl);
      });
      link.addEventListener('keydown',event=>{if(event.key==='Enter')link.classList.add('is-pressed');});
      link.addEventListener('keyup',()=>link.classList.remove('is-pressed'));
      link.addEventListener('blur',()=>link.classList.remove('is-pressed'));
    });
    addEventListener('pageshow',resetLaunch);
    return;
  }
  if(cfg.continuousEntry && $('[data-site-dialog]'))return;
  const dock=$('[data-game-dock]'), gameDialog=$('[data-game-dialog]');
  let gameFrame, readyTimer, timeoutTimer, lastGameOpener;
  function gameMessage(status, detail){$('[data-game-status]').textContent=status;$('[data-game-detail]').textContent=detail;}
  function gameReady(){
    if(state.game==='ready')return;state.game='ready';clearInterval(readyTimer);clearTimeout(timeoutTimer);
    gameMessage(text('gameReady','Your world is ready.'),text('gameReadyDetail','Come on in. The bears are waiting.'));
    $('[data-game-open]').hidden=false;$('[data-game-retry]').hidden=true;dock.hidden=false;
  }
  function gameError(){
    state.game='error';clearInterval(readyTimer);clearTimeout(timeoutTimer);
    gameMessage(text('gameError','The world needs another moment.'),text('gameErrorDetail','Try loading again, or keep exploring the site.'));
    $('[data-game-retry]').hidden=false;
  }
  function startGame(e){
    lastGameOpener=e?.currentTarget||lastGameOpener;dock.hidden=false;
    if(state.game==='ready'){openGame();return;}
    if(state.game==='loading')return;
    if(!cfg.gameUrl){state.game='unavailable';gameMessage(text('gameSoon','Bubble World is getting ready.'),text('gameSoonDetail','Keep exploring. We’ll share more from the world soon.'));return;}
    state.game='loading';gameMessage(text('gameLoading','Getting your world ready…'),text('gameLoadingDetail','Keep exploring while Bubble World loads.'));
    $('[data-game-open]').hidden=true;$('[data-game-retry]').hidden=true;
    $('.bb-world')?.classList.add('is-entering');setTimeout(()=>$('.bb-world')?.classList.remove('is-entering'),900);
    gameFrame?.remove();gameFrame=document.createElement('iframe');gameFrame.title='Bubble World';gameFrame.className='bb-game-warming';gameFrame.tabIndex=-1;gameFrame.setAttribute('aria-hidden','true');
    gameFrame.allow='autoplay; fullscreen; gamepad';gameFrame.src=cfg.gameUrl;
    // Keep the engine's browsing context in one place. Moving an iframe reloads it.
    gameDialog.append(gameFrame);
    gameFrame.addEventListener('error',gameError);
    readyTimer=setInterval(()=>{
      try{
        const win=gameFrame.contentWindow,doc=gameFrame.contentDocument;
        const start=doc?.querySelector('#start-button');
        if(start&&!start.disabled&&!start.hidden)start.click();
        if(win?.__bubbleworldLoadState?.ready)gameReady();
      }catch{/* Cross-origin hosts must emit the documented readiness message. */}
    },500);
    timeoutTimer=setTimeout(gameError,90000);
  }
  function openGame(){
    if(!gameFrame||state.game!=='ready')return;
    gameDialog.showModal();dock.hidden=true;
    gameFrame.className='bb-game-playing';gameFrame.removeAttribute('aria-hidden');gameFrame.tabIndex=0;gameFrame.focus();
  }
  $$('[data-game-start]').forEach(b=>b.addEventListener('click',startGame));
  $$('.bb-enter').forEach(button=>{
    button.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' ')button.classList.add('is-pressed');});
    button.addEventListener('keyup',event=>{if(event.key==='Enter'||event.key===' ')button.classList.remove('is-pressed');});
    button.addEventListener('blur',()=>button.classList.remove('is-pressed'));
  });
  $('[data-game-open]')?.addEventListener('click',openGame);
  $('[data-game-retry]')?.addEventListener('click',startGame);
  $('[data-game-dismiss]')?.addEventListener('click',()=>{dock.hidden=true;});
  $('[data-game-close]')?.addEventListener('click',()=>gameDialog.close());
  gameDialog?.addEventListener('close',()=>{
    if(gameFrame){gameFrame.className='bb-game-warming';gameFrame.setAttribute('aria-hidden','true');gameFrame.tabIndex=-1;}
    dock.hidden=false;lastGameOpener?.focus({preventScroll:true});
  });
  addEventListener('message',event=>{
    if(!gameFrame||event.source!==gameFrame.contentWindow)return;
    let expected;try{expected=new URL(cfg.gameUrl,location.href).origin;}catch{return;}
    if(event.origin!==expected)return;
    if(event.data?.type==='bubbleworld:ready')gameReady();
    if(event.data?.type==='bubbleworld:error')gameError();
  });
})();

(() => {
  const host=document.querySelector('[data-bb-review]');
  if(!host || host.dataset.storefrontReady)return;
  host.dataset.storefrontReady='true';
  const cfg=window.BB_REVIEW_CONFIG || {};
  const text=(key,fallback)=>cfg.strings?.[key] || fallback;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  const asset=name=>/^(https?:|\/)/.test(name)?name:(cfg.assets?.[name] || `assets/${name}`);
  const flavors={
    strawberry:{name:'Strawberry lemonade.',short:'Strawberry',description:text('strawberryDescription','Sweet strawberry meets bright lemonade.')},
    mango:{name:'Mango lemonade.',short:'Mango',description:text('mangoDescription','Juicy mango with a bright lemon finish.')},
    lychee:{name:'Lychee lemonade.',short:'Lychee',description:text('lycheeDescription','Delicate lychee with a refreshing citrus finish.')}
  };
  const state=window.__BBStorefront={flavor:'strawberry',flavorPaused:false,crewWelcomed:false};
  const motionPaused=()=>reduce.matches || window.__BBReview?.motionPaused;
  const feature=host.querySelector('[data-flavors]');
  if(feature){
    const keys=Object.keys(flavors), scenes=[...feature.querySelectorAll('[data-flavor-scene]')];
    let selected='strawberry',visible=false,focused=false,timer,transitionTimers=[],imagesReady;
    const prepareImages=()=>{
      host.dispatchEvent(new CustomEvent('bb:load-media',{detail:{root:feature}}));
      return imagesReady ||= Promise.all(scenes.flatMap(s=>[...s.querySelectorAll('img')]).map(i=>{
        // Hidden upcoming flavors must be ready before the next transition.
        // Upgrade loading only when this section reaches the visitor.
        i.loading='eager';return i.decode().catch(()=>{});
      }));
    };
    function schedule(){
      clearTimeout(timer);
      state.flavorPaused=motionPaused() || !visible || focused || document.hidden;
      if(!state.flavorPaused)timer=setTimeout(()=>select(keys[(keys.indexOf(selected)+1)%keys.length]),3800);
    }
    function clearTransition(){transitionTimers.forEach(clearTimeout);transitionTimers=[];}
    function settle(){
      clearTransition();feature.dataset.flavor=selected;feature.dataset.flavorPhase='idle';
      feature.querySelector('[data-flavor-name]').textContent=flavors[selected].name;
      const description=feature.querySelector('[data-flavor-description]');if(description)description.textContent=flavors[selected].description;
      feature.querySelectorAll('[data-feature-flavor]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.featureFlavor===selected)));
      feature.querySelector('.bb-order-bottles').href=(cfg.routes?.bottles || 'bottles.html')+'#'+selected;
      scenes.forEach(scene=>{
        const current=scene.dataset.flavorScene===selected;
        scene.classList.remove('is-leaving');scene.classList.toggle('is-current',current);
        scene.setAttribute('aria-hidden',String(!current));
      });
    }
    function select(key){
      if(!flavors[key] || selected===key)return;
      clearTimeout(timer);clearTransition();
      const previous=selected;selected=key;state.flavor=key;
      scenes.forEach(scene=>{
        scene.classList.toggle('is-leaving',scene.dataset.flavorScene===previous && !motionPaused());
        scene.classList.remove('is-current');scene.setAttribute('aria-hidden','true');
      });
      const changeColor=()=>{
        feature.dataset.flavor=key;feature.dataset.flavorPhase='color';
        scenes.forEach(s=>s.classList.remove('is-leaving'));
        feature.querySelector('[data-flavor-name]').textContent=flavors[key].name;
        const description=feature.querySelector('[data-flavor-description]');if(description)description.textContent=flavors[key].description;
        feature.querySelectorAll('[data-feature-flavor]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.featureFlavor===key)));
        feature.querySelector('.bb-order-bottles').href=(cfg.routes?.bottles || 'bottles.html')+'#'+key;
      };
      if(motionPaused()){changeColor();settle();schedule();return;}
      // The existing campaign images include colored backdrops. Never crossfade
      // them over a different surface: exit, change the field, then enter.
      feature.dataset.flavorPhase='leaving';
      transitionTimers.push(setTimeout(changeColor,260));
      transitionTimers.push(setTimeout(()=>{settle();schedule();},580));
    }
    settle();
    feature.querySelectorAll('[data-feature-flavor]').forEach(b=>b.addEventListener('click',()=>{focused=b.matches(':focus-visible');select(b.dataset.featureFlavor);schedule();}));
    let introduced=false;
    new IntersectionObserver(e=>{if(e[0].isIntersecting && !introduced){introduced=true;if(!motionPaused())feature.classList.add('is-introducing');}},{threshold:.15}).observe(feature);
    // Keyboard users can finish an action without its context rotating away.
    feature.addEventListener('focusin',e=>{focused=e.target.matches(':focus-visible');schedule();});
    feature.addEventListener('focusout',()=>requestAnimationFrame(()=>{focused=feature.contains(document.activeElement) && document.activeElement.matches(':focus-visible');schedule();}));
    new IntersectionObserver(e=>{visible=e[0].isIntersecting;if(visible)prepareImages().then(schedule);else schedule();},{threshold:.25}).observe(feature);
    const motionChange=()=>{if(motionPaused() || document.hidden)settle();schedule();};
    document.addEventListener('visibilitychange',motionChange);host.addEventListener('bb:motion-change',motionChange);reduce.addEventListener('change',motionChange);schedule();
  }
  const stand=host.querySelector('[data-stand-pan]');
  if(stand){
    let visible=false;
    function update(){stand.classList.toggle('is-panning',visible && !motionPaused() && !document.hidden && !navigator.connection?.saveData);}
    new IntersectionObserver(e=>{visible=e[0].isIntersecting;update();},{threshold:.1}).observe(stand);
    host.addEventListener('bb:motion-change',update);reduce.addEventListener('change',update);document.addEventListener('visibilitychange',update);update();
  }
  // Only a future/current, configured stop can supply directions. Never reuse an expired event.
  const events=(cfg.events || []).filter(e=>e.title && (e.startsAt ? Number.isFinite(Date.parse(e.startsAt)) && Date.parse(e.endsAt)>Date.now() : /^\d{4}-\d{2}-\d{2}$/.test(e.date || '') && e.date>=new Intl.DateTimeFormat('en-CA',{timeZone:cfg.eventTimeZone || 'America/New_York'}).format(new Date()))).sort((a,b)=>Date.parse(a.startsAt || a.date)-Date.parse(b.startsAt || b.date));
  const list=host.querySelector('[data-event-list]');
  // Replace the server-rendered fallback once; never append duplicate events.
  if(list)list.replaceChildren();
  host.querySelector('[data-events-empty]')?.toggleAttribute('hidden', Boolean(events.length));
  if(list && events.length){
    host.querySelector('[data-events-empty]')?.setAttribute('hidden','');
    const display=new Intl.DateTimeFormat('en-US',{timeZone:cfg.eventTimeZone || 'America/New_York',weekday:'long',month:'short',day:'numeric'});
    const hours=new Intl.DateTimeFormat('en-US',{timeZone:cfg.eventTimeZone || 'America/New_York',hour:'numeric',minute:'2-digit'});
    const stamp=value=>new Date(value).toISOString().replace(/[-:]/g,'').replace(/\.\d{3}/,'');
    const clean=value=>String(value || '').replace(/\\/g,'\\\\').replace(/\n/g,'\\n').replace(/,/g,'\\,').replace(/;/g,'\\;');
    events.slice(0,list.hasAttribute('data-all-events')?events.length:3).forEach((event,eventIndex)=>{
      const card=document.createElement('article');card.className='bb-event-card';card.setAttribute('role','listitem');
      const date=document.createElement('time');date.dateTime=event.startsAt || event.date;date.textContent=display.format(new Date(event.startsAt || event.date+'T12:00:00-04:00'));
      const title=document.createElement('h3');title.textContent=event.title;
      const when=document.createElement('p');when.textContent=event.startsAt ? hours.format(new Date(event.startsAt))+' – '+hours.format(new Date(event.endsAt)) : text('eventHoursPending','Hours will be confirmed shortly.');
      const where=document.createElement('p');where.textContent=[event.venue,event.address].filter(Boolean).join(' · ');
      const nav=document.createElement('nav');nav.setAttribute('aria-label',event.title+' '+date.textContent);
      if(event.mapUrl){try{const map=document.createElement('a');const u=new URL(event.mapUrl);if(u.protocol==='https:'){map.href=u.href;map.textContent=text('eventDirections','Directions');map.target='_blank';map.rel='noopener noreferrer';nav.append(map);}}catch{}}
      if(event.startsAt && event.endsAt){
      const calendar=document.createElement('a');calendar.textContent=text('eventCalendar','Add to calendar');calendar.download='bubble-bears-market.ics';
      const ics=['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Bubble Bears//Events//EN','BEGIN:VEVENT','UID:'+stamp(event.startsAt)+'@bubblebears.co','DTSTAMP:'+stamp(new Date()),'DTSTART:'+stamp(event.startsAt),'DTEND:'+stamp(event.endsAt),'SUMMARY:'+clean(event.title),'LOCATION:'+clean([event.venue,event.address].filter(Boolean).join(', ')),'END:VEVENT','END:VCALENDAR'].join('\r\n');
      calendar.href=URL.createObjectURL(new Blob([ics],{type:'text/calendar;charset=utf-8'}));nav.append(calendar);
      }
      const share=document.createElement('button');share.type='button';share.textContent=text('eventShare','Share');share.addEventListener('click',async()=>{
        const url=new URL((cfg.routes?.home || 'index.html')+'#events',location.href).href;
        try{if(navigator.share)await navigator.share({title:event.title,text:date.textContent+' · '+when.textContent,url});else{await navigator.clipboard.writeText(url);share.textContent=text('eventCopied','Link copied');setTimeout(()=>share.textContent=text('eventShare','Share'),2000);}}catch{}
      });nav.append(share);
      const contact=document.createElement('a');contact.href='mailto:info@drinkbubblebears.com';contact.textContent=text('eventContact','Contact us');nav.append(contact);
      if(event.appleMapUrl){try{const url=new URL(event.appleMapUrl);if(url.protocol==='https:'){const a=document.createElement('a');a.href=url.href;a.target='_blank';a.rel='noopener noreferrer';a.textContent=text('eventAppleMaps','Apple Maps');nav.append(a);}}catch{}}
      card.append(date,title,when,where,nav);
      if(eventIndex===0){
        const photo=document.createElement('img');photo.loading='lazy';photo.decoding='async';if(cfg.deferBelowFoldMedia)photo.dataset.bbSrc=asset('feed-04.webp');else photo.src=asset('feed-04.webp');photo.alt=text('eventPhoto','Bubble Bears at the market');photo.width=1080;photo.height=1282;card.prepend(photo);
        const socials=document.createElement('div');socials.className='bb-event-socials';
        [['Instagram','https://www.instagram.com/drinkbubblebears/'],['TikTok','https://www.tiktok.com/@drinkbubblebears']].forEach(([name,url])=>{const a=document.createElement('a');a.href=url;a.target='_blank';a.rel='noopener noreferrer';a.setAttribute('aria-label',name);const img=document.createElement('img');img.src=asset('icon-'+name.toLowerCase()+'.svg');img.width=24;img.height=24;img.alt='';a.append(img);socials.append(a);});card.append(socials);
        if(event.startsAt){const countdown=document.createElement('p');countdown.className='bb-event-countdown';const tick=()=>{const seconds=Math.max(0,Math.floor((Date.parse(event.startsAt)-Date.now())/1000));countdown.textContent=seconds?text('eventCountdown','Until we open')+' · '+Math.floor(seconds/86400)+'d '+Math.floor(seconds%86400/3600)+'h '+Math.floor(seconds%3600/60)+'m':text('eventOpen','We’re at the market!');};tick();setInterval(tick,60000);card.append(countdown);}
      }
      list.append(card);
      host.dispatchEvent(new CustomEvent('bb:observe-media',{detail:{root:card}}));
    });
  }
  const next=events[0];
  host.querySelectorAll('[data-event-map]').forEach(link=>{
    if(next?.mapUrl){link.href=next.mapUrl;link.removeAttribute('aria-disabled');link.setAttribute('aria-label','Directions to '+next.title);link.title='Directions to '+next.title;}
    else {link.removeAttribute('href');link.setAttribute('aria-disabled','true');link.setAttribute('aria-label','Event directions will be available when the next location is announced');link.title='Next location announced soon';}
  });
  const eventFeature=host.querySelector('[data-event-feature]');
  if(eventFeature && next){
    eventFeature.querySelector('[data-event-title]').textContent=next.title;
    eventFeature.querySelector('[data-event-location]').textContent=[next.venue,next.address].filter(Boolean).join(' · ');
    const date=eventFeature.querySelector('[data-event-date]');
    date.textContent=new Intl.DateTimeFormat('en-US',{timeZone:cfg.eventTimeZone || 'America/New_York',weekday:'long',month:'long',day:'numeric',hour:'numeric',minute:'2-digit'}).format(new Date(next.startsAt));
    date.dateTime=next.startsAt;date.hidden=false;
    eventFeature.querySelector('[data-event-empty]').hidden=true;
    eventFeature.querySelector('[data-event-directions]').hidden=!next.mapUrl;
  }
  host.querySelectorAll('[data-newsletter-form],.bb-newsletter-form').forEach(form=>{
    form.addEventListener('submit',async event=>{
      if(new URL(form.action).origin!==location.origin || !window.fetch)return;
      if(!form.reportValidity())return;
      event.preventDefault();
      if(form.dataset.submitting)return;
      const button=form.querySelector('button[type="submit"]');
      const status=form.querySelector('[data-newsletter-result]') || form.querySelector('[data-newsletter-status]');
      if(!button || !status)return;
      const label=button.textContent;
      const data=new FormData(form);data.set('return_to',location.pathname+location.search+'#signup');
      form.dataset.submitting='true';form.setAttribute('aria-busy','true');button.disabled=true;
      button.textContent=text('signupSending','Signing up…');status.textContent='';
      try{
        const response=await fetch(form.action,{method:'POST',body:data,credentials:'same-origin',signal:AbortSignal.timeout(20000)});
        const result=new DOMParser().parseFromString(await response.text(),'text/html');
        const feedback=result.querySelector('[data-newsletter-result]');
        if(response.ok && feedback?.dataset.newsletterResult==='success'){
          status.textContent=feedback.textContent;status.classList.add('bb-newsletter-success');
          const fields=form.querySelector('[data-newsletter-fields]') || form.querySelector('.bb-newsletter-fields');if(fields)fields.hidden=true;
          form.dataset.complete='true';
          host.dispatchEvent(new CustomEvent('bb:newsletter-confirmed'));
        }else if(feedback?.dataset.newsletterResult==='error'){
          status.textContent=feedback.textContent;
        }else{
          const url=new URL(response.url);
          const continuation=form.querySelector('[data-newsletter-continue]');
          if(url.origin===location.origin && url.pathname==='/challenge' && continuation){
            status.textContent=text('signupCheck','Shopify needs a quick check to finish your signup.');continuation.href=url.href;continuation.hidden=false;
          }else throw new Error('Unconfirmed signup');
        }
      }catch{
        status.textContent=text('signupRetry','We couldn’t confirm your signup. Check your inbox, or try again.');
      }finally{delete form.dataset.submitting;form.removeAttribute('aria-busy');button.disabled=false;button.textContent=label;}
    });
  });
  const catalog=host.querySelector('[data-bottle-catalog]');
  if(catalog){
    const buttons=[...catalog.querySelectorAll('[data-bottle-select]')];
    const detail=catalog.querySelector('[data-bottle-detail]');
    function selectBottle(key,announce=false){
      if(!flavors[key])key='strawberry';
      catalog.dataset.flavor=key;
      buttons.forEach(b=>{const selected=b.dataset.bottleSelect===key;b.setAttribute('aria-pressed',String(selected));b.querySelector('span').textContent=selected?'Selected':'Choose '+flavors[b.dataset.bottleSelect].short.toLowerCase();});
      detail.querySelector('[data-selected-flavor]').textContent=flavors[key].name;
      detail.querySelector('[data-selected-description]').textContent=flavors[key].description;
      const buy=detail.querySelector('[data-bottle-buy]');
      const url=cfg.bottleShop?.flavorUrls?.[key];
      // Actual Shopify destinations only. No synthetic cart, variants or prices.
      buy.hidden=!url;
      if(url)buy.href=url;
      detail.querySelector('[data-ordering-soon]').hidden=!!url;
      if(announce){history.replaceState(null,'','#'+key);catalog.querySelector('[data-catalog-status]').textContent=flavors[key].short+' lemonade selected.';detail.scrollIntoView({behavior:reduce.matches?'instant':'smooth',block:'center'});}
    }
    buttons.forEach(b=>b.addEventListener('click',()=>selectBottle(b.dataset.bottleSelect,true)));
    selectBottle(location.hash.slice(1));
    addEventListener('hashchange',()=>{if(flavors[location.hash.slice(1)])selectBottle(location.hash.slice(1));});
  }
  const product=host.querySelector('[data-merch-product]');
  if(product){
    const mainImage=product.querySelector('[data-product-image]');
    const photos=[...product.querySelectorAll('[data-product-photo]')];
    function showPhoto(url){
      if(!url || !mainImage)return;
      mainImage.removeAttribute('srcset');mainImage.src=url;
      photos.forEach(a=>a.setAttribute('aria-current',String(a.dataset.image===url)));
    }
    photos.forEach(a=>a.addEventListener('click',event=>{
      if(event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
      event.preventDefault();showPhoto(a.dataset.image);
    }));
    const variants=product.querySelector('[data-product-variant]');
    const form=product.querySelector('[data-merch-form]');
    if(variants && form){
      const quantity=form.elements.quantity,add=form.querySelector('[data-product-add]');
      const status=form.querySelector('[data-product-status]');
      function updateVariant(announce=false){
        const option=variants.selectedOptions[0];
        if(!option)return;
        product.querySelector('[data-product-price]').textContent=option.dataset.price;
        add.disabled=option.dataset.available!=='true';
        add.firstChild.textContent=add.disabled?add.dataset.soldLabel:add.dataset.availableLabel;
        quantity.min=option.dataset.min || '1';quantity.step=option.dataset.step || '1';
        if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');
        quantity.value=quantity.min;
        showPhoto(option.dataset.image);
        if(announce){
          const url=new URL(location.href);url.searchParams.set('variant',option.value);
          history.replaceState(null,'',url);status.textContent=option.textContent.trim();
        }
      }
      variants.addEventListener('change',()=>updateVariant(true));
      // Native form submission preserves Shopify inventory checks, cart errors and checkout.
      form.addEventListener('submit',event=>{if(add.disabled)event.preventDefault();});
      addEventListener('pageshow',()=>updateVariant(false));updateVariant(false);
    }
  }
  // Future delivery menus live in one configuration, with no dead external links.
  host.querySelectorAll('[data-delivery-provider]').forEach(el=>{
    const key=el.dataset.deliveryProvider;
    const url=key==='uberEats'?cfg.delivery?.uberEatsUrl:cfg.delivery?.doorDashUrl;
    if(!url)return;
    const a=document.createElement('a');a.className=el.className;a.href=url;a.target='_blank';a.rel='noopener noreferrer';
    a.innerHTML=el.innerHTML;a.querySelector('span').textContent='View our menu';el.replaceWith(a);
  });
})();

/* Optional Shopify custom events. No separate tracker, identifiers or cookies.
   Shopify's native commerce events remain authoritative for cart and checkout. */
(() => {
  const host = document.querySelector('[data-bb-review]');
  if (!host || host.dataset.measurementReady) return;
  host.dataset.measurementReady = 'true';
  const cfg = window.BB_REVIEW_CONFIG || {};
  const allowedActions = new Set(['game_entry', 'shop_bottles', 'shop_merch', 'find_event', 'event_directions', 'social_instagram', 'social_tiktok', 'newsletter_success']);
  const publish = action => {
    // Reviews must never pollute a future launch funnel. Missing/denied consent
    // fails closed; never retain or replay actions taken before consent.
    if (!allowedActions.has(action) || cfg.measurementEnabled !== true) return;
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      const analytics = window.Shopify?.analytics;
      if (typeof analytics?.publish !== 'function') return;
      Promise.resolve(analytics.publish('bubblebears:site_action', {
        action,
        surface: document.querySelector('.bb-world') ? 'home' : 'shop_or_info'
      })).catch(() => {});
    } catch { /* A metrics integration must never interrupt a customer action. */ }
  };
  host.addEventListener('click', event => {
    const a = event.target.closest('a[href]');
    if (!a || event.button > 0) return;
    if (a.hasAttribute('data-game-start')) { publish('game_entry'); return; }
    let url;
    try { url = new URL(a.href, location.href); } catch { return; }
    if (url.hostname === 'www.instagram.com') publish('social_instagram');
    else if (url.hostname === 'www.tiktok.com') publish('social_tiktok');
    else if (url.hostname === 'maps.apple.com' || url.hostname === 'maps.google.com' || (url.hostname === 'www.google.com' && url.pathname.startsWith('/maps'))) publish('event_directions');
    else if (url.origin === location.origin) {
      const target = url.pathname + url.search;
      if (/bottles|\/pages\/menu$/.test(target)) publish('shop_bottles');
      else if (/merch/.test(target)) publish('shop_merch');
      else if (url.hash === '#events' || /events/.test(target)) publish('find_event');
    }
  });
  host.addEventListener('bb:newsletter-confirmed', () => publish('newsletter_success'));
})();

(() => {
  const cfg = window.BB_REVIEW_CONFIG || {};
  const root = document.querySelector('[data-bb-review]');
  const stage = root?.querySelector('[data-live-game]');
  if (!cfg.liveEntry || !stage || !window.HTMLDialogElement || !window.crypto?.randomUUID) return;
  const hero = stage.closest('.bb-world');
  const select = selector => root.querySelector(selector);
  const launchers = [...root.querySelectorAll('[data-game-start]')];
  const status = select('[data-live-status]');
  const recovery = select('[data-live-recovery]');
  const cancel = select('[data-live-cancel]');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const text = (key, fallback) => cfg.strings?.[key] || fallback;
  const labels = new Map(launchers.map(link => [link, link.querySelector('[data-game-label]')?.textContent]));
  const state = window.__BBLiveEntry = {phase:'idle', instances:0, ready:false, played:false, requested:false, storage:'checking', connected:false};
  let frame, childOrigin, channel, timer, visible = true, intent = false, opener, playingBeforeHide = false;
  function send(type, payload = {}) {
    if (frame?.contentWindow && childOrigin) frame.contentWindow.postMessage({type, version:1, channel, ...payload}, childOrigin);
  }
  function message(value = '') { status.textContent = value; status.hidden = !value; }
  function label(busy = false) {
    launchers.forEach(link => {
      link.toggleAttribute('aria-busy', busy);
      if (busy) link.setAttribute('aria-busy','true');
      const span = link.querySelector('[data-game-label]');
      if (span) span.textContent = state.played ? text('liveResume','Keep playing') : labels.get(link);
    });
  }
  function mediaState() {
    root.dispatchEvent(new CustomEvent('bb:game-state', {detail:{open:stage.open}}));
  }
  function updateVisibility() {
    const active = !document.hidden && (stage.open || intent || visible && !state.played);
    send('bubblebears:visibility', {visible:active, reducedMotion:reduce.matches});
    if (!active) send('bubblebears:suspend');
  }
  function cancelIntent() {
    intent = false; cancel.hidden = true; label(); message();
    updateVisibility();
  }
  function fail() {
    clearTimeout(timer); state.phase = 'error'; state.ready = false; state.requested = false;
    stage.classList.remove('is-presented');
    if (stage.open) stage.close();
    mediaState(); label(); cancel.hidden = true;
    if (intent) { message(text('liveError','The game couldn’t load here. Try again or open it separately.')); recovery.hidden = false; }
  }
  function prepare() {
    if (frame || state.phase === 'error') return;
    let url;
    try {
      url = new URL(cfg.liveGameUrl);
      const production = url.origin === 'https://bubbleworld-testers.cuberhino.chatgpt.site';
      const local = location.hostname === '127.0.0.1' && url.hostname === '127.0.0.1' && url.protocol === 'http:';
      if (!production && !local) throw new Error('Unsupported game origin');
    } catch { fail(); return; }
    channel = crypto.randomUUID(); childOrigin = url.origin;
    url.searchParams.set('embed','website'); url.searchParams.set('parent_origin', location.origin); url.searchParams.set('channel', channel);
    state.phase = 'loading'; state.instances++; state.connected = false;
    frame = document.createElement('iframe');
    frame.dataset.liveGameFrame = ''; frame.title = text('liveFrameTitle','Bubbleworld game');
    frame.allow = 'autoplay; fullscreen; gamepad; storage-access';
    frame.tabIndex = -1; frame.inert = true; frame.setAttribute('aria-hidden','true');
    frame.addEventListener('load', () => send('bubblebears:connect', {visible:(visible || intent || stage.open) && !document.hidden, reducedMotion:reduce.matches}));
    frame.addEventListener('error', fail);
    frame.src = url.href; stage.prepend(frame);
    timer = setTimeout(fail, 120000);
  }
  function enter() {
    if (!intent || !state.ready || document.hidden || state.requested) return;
    select('[data-menu-dialog]')?.close();
    state.requested = true; state.phase = 'starting'; stage.classList.remove('is-playing');
    if (!stage.open) stage.showModal();
    stage.classList.add('is-presented'); frame.inert = false; frame.tabIndex = 0; frame.removeAttribute('aria-hidden');
    cancel.hidden = true; label(); message(); recovery.hidden = true; mediaState();
    send('bubblebears:visibility', {visible:true, reducedMotion:reduce.matches});
    // Promote the existing canvas before asking the game to turn. No film turn,
    // URL change or new browsing context is created here.
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (!stage.open || !intent) return;
      send(state.played ? 'bubblebears:resume' : 'bubblebears:play');
      frame.focus({preventScroll:true});
    }));
  }
  function launch(event) {
    if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); opener = event.currentTarget;
    if (stage.open || state.requested) return;
    intent = true;
    if (state.phase === 'error') { fail(); return; }
    prepare();
    updateVisibility();
    if (state.ready) enter();
    else { label(true); cancel.hidden = false; message(); }
  }
  function returned() {
    intent = false; state.requested = false; stage.classList.remove('is-playing');
    send('bubblebears:suspend');
    if (frame) { frame.inert = true; frame.tabIndex = -1; frame.setAttribute('aria-hidden','true'); }
    const failed = state.phase === 'error';
    if (!failed) state.phase = state.played ? 'paused' : state.ready ? 'ready' : state.phase;
    stage.classList.remove('is-presented');
    label(); cancel.hidden = true;
    if (failed) { message(text('liveError','The game couldn’t load here. Try again or open it separately.')); recovery.hidden = false; }
    else message();
    mediaState(); updateVisibility();
    const focusTarget = opener?.getClientRects().length ? opener : select('[data-menu-open]');
    focusTarget?.focus({preventScroll:true});
  }
  stage.addEventListener('cancel', event => { event.preventDefault(); stage.close(); });
  stage.addEventListener('close', returned);
  select('[data-live-return]').addEventListener('click', () => stage.close());
  cancel.addEventListener('click', cancelIntent);
  select('[data-live-retry]').addEventListener('click', () => {
    clearTimeout(timer); frame?.remove(); frame = null;
    Object.assign(state, {phase:'idle', ready:false, played:false, requested:false, connected:false});
    recovery.hidden = true; intent = true; label(true); cancel.hidden = false;
    message(); prepare();
  });
  launchers.forEach(link => {
    link.addEventListener('click', launch);
    link.addEventListener('keydown', event => { if (event.key === ' ') {event.preventDefault(); link.click();} });
  });
  addEventListener('message', event => {
    if (!frame || event.source !== frame.contentWindow || event.origin !== childOrigin) return;
    const data = event.data;
    if (!data || typeof data !== 'object' || data.version !== 1 || data.channel !== channel) return;
    if (data.type === 'bubbleworld:connected') { state.connected = true; return; }
    if (data.type === 'bubbleworld:storage') { state.storage = data.state; return; }
    if (data.type === 'bubbleworld:error') { fail(); return; }
    if (data.type === 'bubbleworld:ready' && data.firstFrame === true && data.playable === true) {
      clearTimeout(timer); state.ready = true; state.build = data.build; state.storage = data.storage;
      if (!state.played && !state.requested) state.phase = 'ready';
      mediaState(); updateVisibility(); enter();
    }
    if (data.type === 'bubbleworld:playing') {
      state.played = true; state.requested = false; intent = false;
      state.phase = stage.open ? 'playing' : 'paused'; stage.classList.toggle('is-playing',stage.open); label();
      if (!stage.open) {send('bubblebears:suspend'); stage.classList.remove('is-presented'); mediaState();}
    }
    if (data.type === 'bubbleworld:open-site' && stage.open) stage.close();
  });
  new IntersectionObserver(entries => {visible = entries[0].isIntersecting; updateVisibility();}, {threshold:.1}).observe(hero);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {playingBeforeHide = stage.open && state.played; if (stage.open && !state.played) stage.close(); updateVisibility();}
    else {updateVisibility(); if (playingBeforeHide && stage.open) send('bubblebears:resume'); else enter(); playingBeforeHide = false;}
  });
  reduce.addEventListener('change', updateVisibility);
  // Begin on first paint, including phones. Loading never waits for the entry click.
  requestAnimationFrame(() => requestAnimationFrame(prepare));
})();
